import React from 'react';
import useStore from "../store";
import HudBones from "./HudBones";
import HudAlerts from "./HudAlerts";


function TravelHud() {
    const scrollContainer = React.useRef();
    const pointActive = useStore(state => state.pointActive);
    const cellInit = useStore(state => state.station);
    const startMove = useStore(state => state.startMove);

    const cell = startMove ? pointActive : cellInit;
    const lastCell = useStore(state => state.lastCell);
    const meteorits = useStore(state => state.meteorits);
    const current = Number.isInteger(cell / 17) ? (Math.floor(cell / 17)) - 1 : (Math.floor(cell / 17));
    const currentCheck = cell < 103 ? cell === 0 ? 0 : current : 5
    const addCell = currentCheck === 0 ? 0 : 1;
    const checkPoint = [1, 18, 35, 52, 69, 86, 103]


    React.useEffect(() => {
        if (!scrollContainer.current) return
        const width = scrollContainer.current.querySelector('.way-element').getBoundingClientRect().width
        scrollContainer.current.scrollTo({
            top: 0,
            left: ((cell - currentCheck * 17) * width) - (3 * width),
            behavior: 'smooth'
        })
    }, [cell, currentCheck])


    const TravelWay = () => {
        let arr = [];
        for (let i = currentCheck * 17 + addCell; i <= ((currentCheck + 1) * 17 + 1); i++) {
            arr.push(
                <div key={i} className={cell > i ? "way-element  active-way" : "way-element"}>
                    <div className={"way-element-progress"}/>
                    {checkPoint.lastIndexOf(i) !== -1 &&
                        <div className={cell >= i ? "way-checkpoint active" : "way-checkpoint"}/>
                    }
                    {meteorits[i] &&
                        <div className={cell >= i ? "way-meteorit active" : "way-meteorit"}/>
                    }
                    <div className={cell >= i ? "way-element-count active" : "way-element-count"}>{i}</div>
                    {i === cell - 1 &&
                        <>
                            <div className={"way-rocket-now"}/>
                            {checkPoint.lastIndexOf(cell) === -1 &&
                                <HudAlerts/>
                            }
                        </>
                    }
                </div>
            )
        }
        return <div className={"way-container"}>{arr}</div>
    }

    return (
        <>
            <div className={"travel-hud"}>
                {(!lastCell && !(cellInit === 103)) &&
                    <HudBones/>
                }

                <div className={"travel-hud-continues"} ref={scrollContainer}>
                    <div
                        className={"travel-hud-continues-info"}
                    >
                        <span>{cell}</span> / 103
                    </div>
                    {TravelWay()}
                </div>
            </div>
        </>
    )
}

export default TravelHud;
